import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { TranslationLanguage } from '../../../../types/translation/translation';
import { LanguageDisplayNames } from '../../../../types/translation/localization.utils';
import DropdownSearchSelect from '../DropdownSearchSelect';

interface LanguageSelectorProps {
  items?: TranslationLanguage[];
  language: TranslationLanguage | undefined;
  setLanguage: (item: TranslationLanguage | undefined) => void;
  label?: boolean;
  tooltip?: string;
}

export default function LanguageSelect({ items, language, setLanguage, label, tooltip }: LanguageSelectorProps) {
  return (
    <DropdownSearchSelect<TranslationLanguage>
      tooltip={tooltip}
      placeholder={t(TranslationKey.selectLanguage, language).singular.upper}
      label={label ? t(TranslationKey.language, language).singular.upper : undefined}
      items={items || Object.values(TranslationLanguage)}
      value={language}
      textBuilder={value => LanguageDisplayNames.get(value) || t(TranslationKey.unknownLanguage).singular.upper}
      onSelect={value => setLanguage(value || undefined)}
    />
  );
}
